import { CSSObject } from "styled-components";

//App
import { vfxTheme } from "./common/VFX-UI/Theme/theme";

interface ComponentGeneralStyles {
    searchContainer: CSSObject;
    activateButton: CSSObject;
    deleteButton: CSSObject;
    actionBarContainer: CSSObject;
    width100: CSSObject;
    pageContent: CSSObject;
    shadowbox: CSSObject;
    textAlignCenter: CSSObject;
    contentCenter: CSSObject;
    sectionHeader: CSSObject;
}

const useComponentGeneralStyles = (): ComponentGeneralStyles => {
    

    return {
        searchContainer: {
            display: "flex",
            marginBottom: vfxTheme.spaceUnits.sp03,
            marginTop: vfxTheme.spaceUnits.sp03,
        },
        activateButton: {
            backgroundColor: vfxTheme.palette.primary.light,
            color: vfxTheme.palette.primary.main,
        },
        deleteButton: {
            backgroundColor: "transparent",
            borderColor: vfxTheme.palette.secondary.light,
            color: vfxTheme.palette.secondary.main,
        },
        actionBarContainer: {
            marginTop: "auto",
        },
        width100: {
            width: "100%",
        },
        pageContent: {
            borderRadius: `${vfxTheme.spaceUnits.sp01}px`,
            backgroundColor: vfxTheme.palette.white,
            //marginTop: `${vfxTheme.spaceUnits.sp01 * 4}px`,
            //marginBottom: `${vfxTheme.spaceUnits.sp04}px`,
            //padding: `${vfxTheme.spaceUnits.sp03}px`,
        },
        shadowbox: {
            boxShadow:
                "0px 1px 4px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.02), 0px 1px 12px rgba(0, 0, 0, 0.12)",
        },
        textAlignCenter: {
            textAlign: "center",
        },
        contentCenter: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            //height: "70vh",
        },
        sectionHeader: {
            fontFamily: vfxTheme.typography.fontFamily,
            color: vfxTheme.palette.text.secondary,
            fontSize: "1.25em",
            textTransform: "none",
            marginBottom: 0
        },
    };
};

export default useComponentGeneralStyles;
